import { render, staticRenderFns } from "./VendorProfileProducts.vue?vue&type=template&id=280a8246"
import script from "./VendorProfileProducts.vue?vue&type=script&lang=js"
export * from "./VendorProfileProducts.vue?vue&type=script&lang=js"
import style0 from "./VendorProfileProducts.vue?vue&type=style&index=0&id=280a8246&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports